<template>
  <span>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Reboot
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-content class="v-list__tile__sub-title" style="white-space: wrap !important;">
              Reboot device
            </v-list-tile-content>
            <v-card-actions>
              <v-btn class='ml-1 oem-text-color' @click='openRebootDialog()'>
                Reboot
              </v-btn>
            </v-card-actions>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
    <msg-dialog
      ref='rebootDialog'
      v-bind:title='`Confirm`'
      v-bind:msg='rebootText'
      v-bind:enabled='rebootDialogEnabled'
    />
    <v-dialog v-model='rebootUpdateDialog' persistent max-width='500px'>
        <v-card>
        <v-card-title class='headline font-weight-regular oem-color'>
          Rebooting
        </v-card-title>
        <v-card-text>
          {{ rebootProgressMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :top='true'
    >
      {{ snackbarText }}
      <v-btn
        class='oem-color-text'
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </span>
</template>

<script>
import msgDialog from './BaseDialog.vue';
import ajax from '../ajax';
import * as auth from '../auth';

export default {
  name: 'Reboot',

  components: {
    msgDialog,
  },

  props: {
    version: String,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      rebootText: 'Are you sure you want to perform a reboot?',
      rebootDialogEnabled: false,

      rebootProgressMessage1: 'Waiting for system to restart.',
      rebootProgressMessage2: 'Waiting for system to come back online.',
      rebootProgressMessage: 'Rebooting....',
      rebootUpdateDialog: false,
      startDateTime: null,
    };
  },
  methods: {
    openRebootDialog() {
      this.$refs.rebootDialog
        .pop()
        .then(() => {
          this.reboot();
        })
        .catch(() => {});
    },
    close() {
      this.rebootDialog = false;
      this.snackbar = true;
      this.snackbarText = 'test';
    },
    reboot() {
      ajax.get('config/static')
        .then((response) => {
          this.startDateTime = response.data.startDateTime;
          ajax.put('system/reboot', { })
            .then(() => {
              this.rebootUpdateDialog = true;
              this.rebootProgressMessage = `${this.rebootProgressMessage1}...`;
              this.$store.addEventLog('Reboot');
              setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
              this.$store.addEventLog(`Failed to perform a reboot. ${e}`);
            });
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.$store.addEventLog(`Failed to perform a reboot. ${e}`);
        });
    },
    checkIfSystemIsShutDown(count) {
      // console.log('Wait untill offline ' + count);
      ajax.get('config/static')
        .then((response) => {
          // Still online (or very quickly rebooted)
          if (this.startDateTime !== response.data.startDateTime) { // If very quickly rebooted
            // Back online
            this.startDateTime = null;
            this.systemRebooted();
          } else {
            if (this.rebootProgressMessage.endsWith('....')) {
              this.rebootProgressMessage = this.rebootProgressMessage1;
            } else {
              this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
            }
            setTimeout(() => { this.checkIfSystemIsShutDown(count + 1); }, 1000);
          }
        })
        .catch(() => {
          setTimeout(() => { this.checkIfSystemIsUp(0); }, 1000);
        });
    },
    checkIfSystemIsUp(count) {
      // console.log('Wait untill online ' + count);
      ajax.get('config/static')
        .then((response) => {
          // Back online
          if (this.startDateTime !== response.data.startDateTime) {
            this.systemRebooted();
          } else { // Apparently not really rebooted, because the startDateTime is still the same
            setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
          }
        })
        .catch(() => {
          // Not yet back online
          if (this.rebootProgressMessage.endsWith('....')) {
            this.rebootProgressMessage = this.rebootProgressMessage2;
          } else {
            this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
          }
          setTimeout(() => { this.checkIfSystemIsUp(count + 1); }, 1000);
        });
    },
    systemRebooted() {
      auth.clearAccessToken();
      window.location.reload();
    },
  },
};
</script>
